"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

export function DirectoryFilters({
  industries,
  initialSearch = "",
  initialIndustry = "",
}: {
  industries: string[];
  initialSearch?: string;
  initialIndustry?: string;
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [search, setSearch] = useState(initialSearch);

  function apply(next: { search?: string; industry?: string }) {
    const params = new URLSearchParams(searchParams.toString());
    const nextSearch = next.search ?? search;
    const nextIndustry = next.industry ?? initialIndustry;
    if (nextSearch.trim()) params.set("q", nextSearch.trim());
    else params.delete("q");
    if (nextIndustry) params.set("industry", nextIndustry);
    else params.delete("industry");
    const query = params.toString();
    router.push(query ? `/directory?${query}` : "/directory");
  }

  return (
    <form
      className="flex flex-col gap-3 sm:flex-row"
      onSubmit={(event) => {
        event.preventDefault();
        apply({ search });
      }}
    >
      <label className="sr-only" htmlFor="directory-search">
        Search directory
      </label>
      <input
        id="directory-search"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        placeholder="Search businesses"
        className="h-11 flex-1 rounded-full border border-slate-200 px-4 text-sm text-slate-900 outline-none ring-[#4f81bd] focus:ring-2"
      />
      <label className="sr-only" htmlFor="directory-industry">
        Industry
      </label>
      <select
        id="directory-industry"
        value={initialIndustry}
        onChange={(event) => apply({ industry: event.target.value })}
        className="h-11 rounded-full border border-slate-200 bg-white px-4 text-sm text-slate-900"
      >
        <option value="">All industries</option>
        {industries.map((industry) => (
          <option key={industry} value={industry}>
            {industry}
          </option>
        ))}
      </select>
      <button
        type="submit"
        className="h-11 rounded-full bg-[#4f81bd] px-5 text-sm font-semibold text-white hover:opacity-95"
      >
        Search
      </button>
    </form>
  );
}
